import { render } from "./FadeList.vue?vue&type=template&id=368735f5&scoped=true"
import script from "./FadeList.vue?vue&type=script&setup=true&lang=js"
export * from "./FadeList.vue?vue&type=script&setup=true&lang=js"

import "./FadeList.vue?vue&type=style&index=0&id=368735f5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-368735f5"],['__file',"src/components/Ui/FadeList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "368735f5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('368735f5', __exports__)) {
    api.reload('368735f5', __exports__)
  }
  
  module.hot.accept("./FadeList.vue?vue&type=template&id=368735f5&scoped=true", () => {
    api.rerender('368735f5', render)
  })

}


export default __exports__